import '../SaveSaleOrderSuccess/SaveSaleOrderSuccess.scss';

import { object } from 'prop-types';
import React, { useEffect, useState } from 'react';

import CPPageHeader from '../CPPageHeader';
import SendSaleOrderSuccessModel from './models/SendSaleOrderSuccessModel';
import SaveSOSuccessBody from '../SaveSaleOrderSuccess/SaveSOSuccessBody';
import SaveSOSuccessFooter from '../SaveSaleOrderSuccess/SaveSOSuccessFooter';
import SaveSOSuccessHeader from '../SaveSaleOrderSuccess/SaveSOSuccessHeader';

const SendSaleOrderSuccess = ({ fields }) => {
  const [layoutData, setLayoutData] = useState(null);
  const isOrderSent = true;

  useEffect(() => {
    const model = new SendSaleOrderSuccessModel();

    setLayoutData(model.getData(fields || {}));
  }, []);

  return layoutData ? (
    <>
      <CPPageHeader title={layoutData?.['Header']?.value.replace('{customerName}', layoutData?.SaleOrder?.Cart?.CustomerName)} />
      <div className='save-so-success'>
        <div className='container tablet-container save-so-success-container'>
          <div className='save-so-success-wrapper'>
            <SaveSOSuccessHeader layoutData={layoutData} />
            <SaveSOSuccessBody layoutData={layoutData} isOrderSent={isOrderSent} />
            <SaveSOSuccessFooter layoutData={layoutData} isOrderSent={isOrderSent} />
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

SendSaleOrderSuccess.propTypes = {
  fields: object
};

export default SendSaleOrderSuccess;
